import { getAuth } from "firebase/auth";
import { cart_URL } from "../utils/constants";

export async function getMyCart() {
  const auth = getAuth();
  const user = auth.currentUser;

  if (user.emailVerified) {
    try {
      let apiUrl = cart_URL;
      const refreshedUser = await user.getIdToken();

      const headers = {
        Authorization: `Bearer ${refreshedUser}`,
        accept: "application/json",
      };

      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        throw new Error("Failed to get cart data");
      }

      const { data } = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching cart:", error);
      throw error;
    }
  }
}
